import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";

export default function Settings(props) {
  const exercices = useSelector((state) => state.exercices);
  const interval = useSelector((state) => state.interval);
  const active = useSelector((state) => state.active);
  const passive = useSelector((state) => state.passive);
  const pause = useSelector((state) => state.pause);
  const lap = useSelector((state) => state.lap);

  const [stateInput, setStateInput] = useState([
    "SQUATS",
    "JUMPING-JACK",
    "BURPEES",
    "MOUNTAIN-CLIMBER",
    "POMPES",
    "CRUNCHS",
    "DIPS",
    "GAINAGE",
  ]);

  const dispatch = useDispatch();

  const toDispatch = (action) => {
    dispatch({
      type: action,
    });
    props.res();
  };

  const intervalDispatch = (action) => {
    const newArr = stateInput;

    if (action === "MORE-INT" && newArr.length < 15) {
      newArr.push(`exercice ${newArr.length + 1}`);
      dispatch({
        type: action,
        key: `exercice ${interval + 1}`,
        tab: stateInput,
      });
    }
    if (action === "LESS-INT" && newArr.length > 2 && newArr.length <= 15) {
      newArr.pop();
      dispatch({
        type: action,
        tab: stateInput,
      });
    }

    props.res();
    setStateInput(newArr);
  };

  const changeInput = (e, key) => {
    const newTab = [...stateInput];

    newTab[key] = e;

    setStateInput(newTab);
  };

  const dispatchExercices = (e) => {
    e.preventDefault();

    dispatch({
      type: "ADD-EX",
      tab: stateInput,
    });
  };

  const [setting, setSetting] = useState(false);

  const toggleSetting = () => {
    setSetting(!setting);
  };

  return (
    <div
      className={
        !setting ? "container-settings" : "container-settings container-active"
      }
    >
      <button
        className={!setting ? "setting" : "setting setting-active"}
        onClick={toggleSetting}
      >
        <i className="fas fa-sliders-h"></i>
      </button>

      <div className={!setting ? "updates" : "updates updates-active"}>
        <div className="timing">
          <div className="interval-lap">
            <div className="title-update">
              <div className="title">intervalles :</div>
              <div className="update interval">
                <button
                  className="btn-setting"
                  onClick={() => intervalDispatch("LESS-INT")}
                >
                  -
                </button>
                <div className="num">{interval}</div>
                <button
                  className="btn-setting"
                  onClick={() => intervalDispatch("MORE-INT")}
                >
                  +
                </button>
              </div>
            </div>

            <div className="title-update">
              <div className="title">tours :</div>
              <div className="update lap">
                <button
                  className="btn-setting"
                  onClick={() => toDispatch("LESS-LAP")}
                >
                  -
                </button>
                <div className="num">{lap}</div>
                <button
                  className="btn-setting"
                  onClick={() => toDispatch("MORE-LAP")}
                >
                  +
                </button>
              </div>
            </div>
          </div>

          <div className="chronos">
            <div className="title-update">
              <div className="title">actif :</div>
              <div className="update active">
                <button
                  className="btn-setting"
                  onClick={() => toDispatch("LESS-ACT")}
                >
                  -
                </button>
                <div className="num">{active}s</div>
                <button
                  className="btn-setting"
                  onClick={() => toDispatch("MORE-ACT")}
                >
                  +
                </button>
              </div>
            </div>
            <div className="title-update">
              <div className="title">repos : </div>
              <div className="update passive">
                <button
                  className="btn-setting"
                  onClick={() => toDispatch("LESS-PAS")}
                >
                  -
                </button>
                <div className="num">{passive}s</div>
                <button
                  className="btn-setting"
                  onClick={() => toDispatch("MORE-PAS")}
                >
                  +
                </button>
              </div>
            </div>
            <div className="title-update">
              <div className="title">pause :</div>
              <div className="update pause">
                <button
                  className="btn-setting"
                  onClick={() => toDispatch("LESS-PAU")}
                >
                  -
                </button>
                <div className="num">{pause}s</div>
                <button
                  className="btn-setting"
                  onClick={() => toDispatch("MORE-PAU")}
                >
                  +
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="ex">
          <div className="title">exercices :</div>
          <form className="inputs" onSubmit={dispatchExercices}>
            {exercices.map((ex, key) => (
              <input
                type="text"
                value={stateInput[key] ? stateInput[key] : ""}
                key={key}
                onChange={(e) => changeInput(e.target.value, key)}
                required
              />
            ))}
            <button
              className="btn-setting"
              type="submit"
              onClick={toggleSetting}
            >
              valider
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
